import React from 'react';
import { getAugmentDefaultSvgPath, AUGMENT_KIND } from '../utils/augmentAssets';
import './TeamRedCards.css';

const RED_CARD_ICON = getAugmentDefaultSvgPath('red-card', AUGMENT_KIND.MATCH);

/**
 * Small red-card stack for one team (home or away).
 * @param {{ count?: number, side?: 'home' | 'away' }} props
 */
export default function TeamRedCards({ count = 0, side = 'home' }) {
  const n = Math.max(0, Number(count) || 0);
  if (n === 0) return null;

  const label = `${n} red card${n === 1 ? '' : 's'} (${side})`;

  return (
    <div className="team-red-cards" title={label} aria-label={label}>
      <img src={RED_CARD_ICON} alt="" className="team-red-cards__icon" />
      {n > 1 && <span className="team-red-cards__count" aria-hidden="true">×{n}</span>}
    </div>
  );
}
